import { ProgramStatus } from "@domain/program/program-status/program-status";

export const useExerciseCardOnboardingAnalytics = (
	_programStatus: ProgramStatus | undefined,
): void => {
	// Touch param to satisfy unused-var lint without any side effect
	if (_programStatus) {
		/* no-op */
	}
	// Alternative exercise tooltip analytics removed
};
